import { Image } from "primereact/image";
import { Toolbar } from 'primereact/toolbar';
import { ProgressBar } from 'primereact/progressbar';

type QuestionStepperPropsHeader = {
    headerName: string;
    position: number;
    totalQuestions: number;
    title: string;
    description: string;
    logo: string | null;
}
const QuestionStepperHeader = (props: QuestionStepperPropsHeader) => {
    const startItem = (
        <div>
            <h3 style={{padding: '0px', marginBottom: "0.5rem"}}>{props.title}</h3>
            <p className="white-space-normal w-4" style={{padding: '0px', margin: "0px"}}>{props.description}</p>
        </div>
    )
    const centerItem = (
        <div style={{display: "flex", justifyContent: "center",alignItems: "center", alignContent:"center", flexDirection: "column"}}>
            <div style={{
                border: "1.5px solid black",
                borderRadius: "50%",
                height: "2.5rem",
                width: "2.5rem",
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
                }}>
                <h3 style={{padding: "0px", margin: "0px"}}>{props.position}</h3>
            </div>
            <p>{props.headerName}</p>
            
        </div>
    );
    
    const getLogo = () => {
        if(!props.logo) return null;
        return <Image className="lg:max-w-14rem max-h-4rem sm:max-w-2rem md:max-w-4rem " src={props.logo} width="60" height="60" style={{padding: "0px", margin: "0px"}} preview />;
    }
    const progressValue = Math.round((props.position / props.totalQuestions) * 100);

    const endItem = (
        <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-end", gap: "0.5rem" }}>
            {getLogo()}
            <div style={{ width: "150px", textAlign: "right" }}>
                <span style={{ fontSize: "0.85rem", color: "var(--text-color-secondary)", display: "block", marginBottom: "4px" }}>
                    {`${progressValue}% completo`}
                </span>
                <ProgressBar 
                    value={progressValue} 
                    showValue={false} 
                    style={{ height: '6px' }} 
                />
            </div>
        </div>
    );


    return (
        <Toolbar
        start={startItem}
        center={centerItem} 
        end={endItem}
        style={{ 
            position: "relative", 
            paddingTop: "3rem",
            borderRadius: "25px 25px 0px 0px" 
        }}
        pt={{
            root: { style: { flexWrap: "nowrap" } },
            center: { style: { 
                position: "absolute", 
                left: "50%", 
                transform: "translateX(-50%)" 
            }}
            ,
        }}
        >

        </Toolbar>
    );
}
export default QuestionStepperHeader;